/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetBillingStatus200Response
 */
export interface GetBillingStatus200Response {
    /**
     * 
     * @type {boolean}
     * @memberof GetBillingStatus200Response
     */
    installation?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetBillingStatus200Response
     */
    stillInTrial?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetBillingStatus200Response
     */
    gracePeriodTriggered?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof GetBillingStatus200Response
     */
    endsAt?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof GetBillingStatus200Response
     */
    expired?: boolean;
}

/**
 * Check if a given object implements the GetBillingStatus200Response interface.
 */
export function instanceOfGetBillingStatus200Response(value: object): value is GetBillingStatus200Response {
    return true;
}

export function GetBillingStatus200ResponseFromJSON(json: any): GetBillingStatus200Response {
    return GetBillingStatus200ResponseFromJSONTyped(json, false);
}

export function GetBillingStatus200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetBillingStatus200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'installation': json['installation'] == null ? undefined : json['installation'],
        'stillInTrial': json['stillInTrial'] == null ? undefined : json['stillInTrial'],
        'gracePeriodTriggered': json['gracePeriodTriggered'] == null ? undefined : json['gracePeriodTriggered'],
        'endsAt': json['endsAt'] == null ? undefined : (new Date(json['endsAt'])),
        'expired': json['expired'] == null ? undefined : json['expired'],
    };
}

export function GetBillingStatus200ResponseToJSON(json: any): GetBillingStatus200Response {
    return GetBillingStatus200ResponseToJSONTyped(json, false);
}

export function GetBillingStatus200ResponseToJSONTyped(value?: GetBillingStatus200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'installation': value['installation'],
        'stillInTrial': value['stillInTrial'],
        'gracePeriodTriggered': value['gracePeriodTriggered'],
        'endsAt': value['endsAt'] == null ? undefined : ((value['endsAt']).toISOString()),
        'expired': value['expired'],
    };
}

